import React from 'react';
import { Api } from 'lavva.exalushome';
import { ExtaLifeService } from 'lavva.exalushome.extalife';
import { GlobalTimeParameters } from 'lavva.exalushome.extalife/build/js/Devices/DeviceServices/Common/OnOffSwitchConfigurations/OnOffSwitchParameters';
import { ISlr22ConfigService } from 'lavva.exalushome.extalife/build/js/Devices/DeviceServices/LedController/ISlr22ConfigService';
import { IDevice } from 'lavva.exalushome/build/js/Services/Devices/IDevice';
import { useConfigurationService } from '../../../device-details/hooks/use-configuration-service';
import { LedTimeType } from '../../../device-details/types';
import TimeForm from '../common/time';

type FloatingTimeFormProps = {
  device: IDevice;
  timeParams: GlobalTimeParameters | null;
  led?: LedTimeType;
};

const FloatingTimeForm: React.FC<FloatingTimeFormProps> = ({ device, timeParams, led }) => {
  const extaLifeService = Api.Get<ExtaLifeService>(ExtaLifeService.ServiceName);
  const { configService: serviceName } = useConfigurationService(device);

  const saveChanges = async (params: GlobalTimeParameters) => {
    const configService = await extaLifeService.GetDeviceServiceByServiceTypeAsync<ISlr22ConfigService>(serviceName);

    return await configService.SetFloatingTimeAsync(device, params);
  };

  return <TimeForm timeParams={timeParams} saveChanges={saveChanges} paramsTitle="FloatingTimeParams" led={led} />;
};

export default FloatingTimeForm;
